document.addEventListener('DOMContentLoaded', function() {
  var items = Array.from(document.querySelectorAll('.faq-item'));

  function closeItem(details) {
    var content = details.querySelector('.faq-answer');
    if (!content) return;
    content.style.height = content.offsetHeight + 'px';
    
    // Force a reflow so the browser catches the height before transitioning to 0
    content.offsetHeight; 
    
    requestAnimationFrame(function() {
      content.style.height = '0px';
    });

    function onClose(e) {
      if (e.propertyName !== 'height') return; 
      details.removeAttribute('open');
      content.style.height = '';
      content.removeEventListener('transitionend', onClose);
    }
    content.addEventListener('transitionend', onClose);
  }

  function openItem(details) {
    details.setAttribute('open', '');
    var content = details.querySelector('.faq-answer');
    if (!content) return;
    var targetHeight = content.scrollHeight;
    
    content.style.height = '0px';
    content.offsetHeight; // Force reflow
    
    requestAnimationFrame(function() {
      content.style.height = targetHeight + 'px';
    });

    function onOpen(e) {
      if (e.propertyName !== 'height') return;
      content.style.height = '';
      content.removeEventListener('transitionend', onOpen);
    }
    content.addEventListener('transitionend', onOpen);
  }

  items.forEach(function(details) {
    var question = details.querySelector('.faq-question');
    if (question) {
      question.addEventListener('click', function(e) {
        e.preventDefault();
        if (details.open) {
          closeItem(details);
        } else {
          // This dynamically closes other open tabs when a new one is clicked
          items.forEach(function(other) {
            if (other !== details && other.open) closeItem(other);
          });
          openItem(details);
        }
      });
    }
  });
});
